// External Dependencies:
import React from 'react'
import { Link, NavLink } from 'react-router-dom'

class InfoPage extends React.Component {
	render() {
		return (
			<div className="mobile-app-top-page">
				<div className="-bg"></div>

				<div className="-menu">
					<NavLink to="/offers" exact activeClassName="is-active">Offers</NavLink>
					<NavLink to="/contact" exact activeClassName="is-active">Contact</NavLink>
					<NavLink to="/about-us" exact activeClassName="is-active">About Us</NavLink>
				</div>
			</div>
		)
	}
}

export default InfoPage
